module.exports = __webpack_public_path__ + "static/img/BUBLY_SMILE-BLUE-POM.835b2bc.835b2bc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/BUBLY_SMILE-BLUE-POM.835b2bc.gif
// module id = SHmK
// module chunks = 0